import {Yii} from "libraries/interfaces/Yii";


/**
 * TEMPLATE LABELS TRANSLATED
 */
export const TEMPLATE_LABELS: { [key: string]: string } = {
    home: Yii.t('wui-sasha-js', 'Accueil'),
    seeMore: Yii.t('wui-sasha-js', 'Voir plus...'),
    bookingSearch: Yii.t('wui-sasha-js', 'Recherche de dossiers'),
    lastBookings: Yii.t('wui-sasha-js', 'Derniers dossiers créés'),
    advSearch: Yii.t('wui-sasha-js', 'Recherche avancée'),
    lastWorks: Yii.t('wui-sasha-js', 'Derniers traitements'),
    bookingsLoading: Yii.t('wui-sasha-js', 'Chargement des derniers dossiers'),
    bookingsError: Yii.t('wui-sasha-js', 'Le chargement des derniers dossiers a échoué'),
    treatmentsError: Yii.t('wui-sasha-js', 'Le chargement des derniers traitements a échoué'),
    treatmentsLoading: Yii.t('wui-sasha-js', 'Chargement des derniers dossiers'),
};
